import React, { Component } from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import HomePage from "./pages/Home/";
import MemberPage from "./pages/Members/";
import NoMatch from "./pages/NoMatch.js";
import DentalPage from "./pages/Dental/";
import VisionPage from "./pages/Vision/";
// import MedicalPage from "./pages/Medical/";
import ProviderPage from "./pages/Providers/";
import EmployerPage from "./pages/Employers/EmployerPage";
import BrokersPage from "./pages/Brokers";
import AboutPage from "./pages/About";
import FormsPage from "./pages/Forms";
import QuotePage from "./pages/Quote";
import NavBar from "./components/dummy/NavBar";
import Banner from "./components/dummy/Banner";
import Footer from "./components/smart/Footer";

class App extends Component {
  constructor(props){
    super(props);
    this.state = { pageReady: false, banner: "Benefits Simplified"};
}
  

  componentDidMount() {
    var AllLinks = document.querySelectorAll("a");
    // I.E doesn't use hostname while all other browsers do; href of each link compared to document hostname to allow IE to identify if external link or not. 
    // protocol always has http or https if it's an external link; final check makes sure those exist; this also excludes tel: and mailto: links. 
    var ExternalLinks = Array.from(AllLinks).filter(link => link.href.search(document.location.hostname)<1 && link.hostname !== document.location.hostname && link.protocol.search('p')>1);
   
    // for each link add onclick function to notify of external link.
    ExternalLinks.forEach(link=> link.onclick = function(e) {
      if(!window.confirm("The link you clicked will take you to our partners website. BAS Benefits provides their site content and online portal."))
      {e.preventDefault()};
      });
    
      var bannerText= "";
      switch(window.location.pathname) {
        case "/":
        case "/Home":
        case "/About":
        case "/Members":
        case "/Providers":
        case "/Brokers":
          bannerText="Benefits Simplified"
          break;
        case "/Employers":
          bannerText="Employer Benefits Simplified"
          break;
        case "/Forms":
          bannerText="Everything You Need"
          break;
        case "/Quote":
          bannerText="Quoting Simplified"
          break;
        case "/VisionPlans":
          bannerText="Vision Simplified"
          break;
        case "/DentalPlans":
          bannerText="Dental Simplified"
          break;
        default:
          bannerText="Benefits Simplified"
          break;
      }
      this.setState({banner: bannerText})
  }

  render() {
    window.onload = (e) => {
      this.setState({pageReady: true});
    }
    return (
      <div>
        <NavBar></NavBar>
        <Banner Title={this.state.banner} pageStatus={this.state.pageReady} />
        <Router>
          <Switch>
            <Route exact path="/" render={(props) => <HomePage {...props} pageStatus={this.state.pageReady} />} />
            <Route exact path="/members" component={MemberPage} />
            <Route exact path="/providers" component={ProviderPage} />
            <Route exact path="/employers" component={EmployerPage} />
            <Route exact path="/brokers" component={BrokersPage} />
            <Route exact path="/about" component={AboutPage} />
            <Route exact path="/forms" component={FormsPage} />
            <Route exact path="/quote" component={QuotePage} />
            <Route exact path="/dentalplans" component={DentalPage} />
            {/* <Route exact path="/medicalplans" component={MedicalPage} /> */}
            <Route exact path="/visionplans" component={VisionPage} />
            <Route exact path="/dental_providers" render={(props) => <MemberPage {...props} ProviderSearch="dental"></MemberPage>} />
            <Route exact path="/medical_providers" render={(props) => <MemberPage {...props} ProviderSearch="medical"></MemberPage>} />
            <Route component={NoMatch} />
          </Switch>
        </Router>
        <Footer />
      </div>
    );
  }
}

export default App;
